/* eslint-disable @typescript-eslint/camelcase */
import { Grid, makeStyles, Typography } from '@material-ui/core';
import { Alert, AlertTitle } from '@material-ui/lab';
import Button from 'components/Button';
import DownloadIcon from '@material-ui/icons/GetApp';
import i18n from 'i18n';
import { FormImportUsers } from 'modules/clients/interfaces';
import React from 'react';
import GenericForm from 'skyone-lib/lib/GenericForm';
import formStyles from '../styles';

const useStyles = makeStyles(formStyles);

export interface Props {
  onSubmit: (values: FormImportUsers) => void;
  onCancel: () => void;
}

export default function FormImport({ onSubmit, onCancel }: Props) {
  const classes = useStyles();
  const [check, setCheck] = React.useState(false);
  const [file, setFile] = React.useState<File>();

  const onChangeFile = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newFile = event.target.files?.[0];
    if (newFile) {
      setFile(newFile);
    }
  };

  const handleSubmit = () => {
    onSubmit({
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      csv_file: file!,
      set_password: check,
    });
  };

  return (
    <Grid item container data-testid={'autosky-formimport'}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Alert severity="info" icon={false}>
            <span>{i18n.t('IMPORT_USER_ALERT_KEY')}</span>
          </Alert>
        </Grid>

        <Grid item xs={12}>
          <Alert severity="info" icon={false}>
            <AlertTitle color="secondary">
              <Typography className={classes.templateText}>
                {i18n.t('TEMPLATE_KEY')}
              </Typography>
            </AlertTitle>
            {i18n.t('CHOOSE_CSV_FILE_KEY')}

            <Button
              variant="outlined"
              color="secondary"
              startIcon={<DownloadIcon />}
              className={classes.buttonDownload}
              href="https://sky-static-develop.s3.amazonaws.com/clientes/template.csv"
            >
              {i18n.t('DOWNLOAD_KEY')}
            </Button>
          </Alert>
        </Grid>

        <Grid item xs={12} className={classes.selectFile}>
          <input
            type="file"
            accept=".csv"
            id="btn-import-file"
            onChange={onChangeFile}
          />
        </Grid>

        <GenericForm
          fields={{ set_password: check }}
          screenFields={[
            {
              gridXs: 12,
              label: i18n.t('CONFIGURE_PASSWORD_KEY'),
              stateKey: 'set_password',
              type: 'checkbox',
              isCheckbox: true,
            },
          ]}
          setFieldValue={(key, value) => setCheck(!!value)}
          errors={[]}
        />
        <Grid container justify="flex-end" className={classes.buttonsBase}>
          <Grid container className={classes.buttonsAlign}>
            <Button
              id="submit-button"
              onClick={handleSubmit}
              disabled={!file}
              submitButton
            >
              {i18n.t('ADD_KEY')}
            </Button>
            <Button id="cancel-button" variant="outlined" onClick={onCancel}>
              {i18n.t('CANCEL_KEY')}
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}
